// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__4zGEF","requiredAsterisk":"Info_requiredAsterisk__3Unb4"};